import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import EvaluationInputBox from './EvaluationInputBox';

export type NewFilterCriteriaCardProps = React.ComponentProps<typeof EvaluationInputBox> & {
  onCancel: () => void;
  cardRef?: React.Ref<HTMLDivElement>;
  /** Tighter padding and gaps when the card sits in the checklist grid */
  compact?: boolean;
};

const NewFilterCriteriaCard: React.FC<NewFilterCriteriaCardProps> = ({
  onCancel,
  cardRef,
  compact = false,
  ...inputProps
}) => (
  <div
    ref={cardRef}
    className={`relative z-30 min-w-0 scroll-mt-28 rounded-2xl border-2 border-dashed border-emerald-300/80 bg-emerald-50/40 shadow-inner shadow-emerald-900/[0.03] md:z-20 md:scroll-mt-24 ${
      compact ? 'p-2 pe-0 md:p-4' : 'p-2 pe-0 md:p-4'
    }`}
  >
    <p className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-emerald-800/80 md:text-xs">
      New criteria
    </p>
    <div className={`flex items-center ${compact ? 'gap-0 md:gap-3' : 'gap-0 md:gap-3'}`}>
      <div className="relative min-w-0 flex-1">
        <EvaluationInputBox {...inputProps} />
      </div>
      <button
        type="button"
        onClick={onCancel}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-red-500 transition-colors hover:bg-red-100"
        aria-label="Cancel adding criterion"
      >
        <FontAwesomeIcon icon={faCircleXmark} className="text-xl" />
      </button>
    </div>
  </div>
);

export default NewFilterCriteriaCard;
